<!--专家委员会-->
<template>
  <div class="common-container">
    <div class="background"></div>
    <Header></Header>

    <div class="main">
      <el-row class="middle">
        <el-col class="middleRight">
          <el-row type="flex" justify="center">
            <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="2"></el-col>
            <el-col :xs="22" :sm="22" :md="22" :lg="20" :xl="20">
              <el-row class="middle">
                <el-col class="middleRight">
                  <el-row type="flex" justify="center">
                    <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6">
                      <organization-aside></organization-aside>
                    </el-col>
                    <el-col :xs="0" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="organization-info-box">
                        <div class="organization-info-title" v-text="name"></div>
                        <div class="organization-info-text" v-html="content"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="2"></el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        name: null,
        content: null,
      };
    },

    components: {},

    watch: {
      //监听相同路由下参数变化
      '$route'(to, from) {
        //每当参数变化时重新获取数据
        // this.getMemberDetail();
        this.getInfo()
      }
    },

    mounted() {
      this.getInfo()
    },

    methods: {
      getInfo() {
        this.instance.get('/api/organization/getdetails', {
          params: {
            id: this.$route.query.id
          }
        }).then(res => {
          if (res.status == 200) {
            this.name = res.data.name;
            this.content = res.data.content;
          }
        })
      },
    },

  }
</script>
<style scoped>
  .common-main-artical {
    height: 700px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Organization.vue